import * as React from 'react';
import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import InternalError from 'components/InternalError';
import type { StatusCode } from 'components/InternalError';
import { clearProtectedValidationCache } from 'routes/_protected';
import { clearZywaveValidationCache } from 'lib/tanstack-router/authGuard';

export const Route = createFileRoute('/error')({
  component: ErrorPageComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      statusCode: (search.statusCode as StatusCode) || '500',
    };
  },
});

function ErrorPageComponent() {
  const search = Route.useSearch();

  // Clear Zywave validation cache when error page is shown
  // so next attempt starts fresh
  useEffect(() => {
    clearProtectedValidationCache();
    clearZywaveValidationCache(); // Keep for backward compatibility
  }, []);

  return <InternalError statusCode={search.statusCode} />;
}
